import { client } from 'lib/evi-api-gateway';

import * as course_itemTypes from 'types/course_item';

const course_item = `${process.env.REACT_APP_API_URL_RESOURCE}/api/course_item`;

export async function get_list(params: course_itemTypes.get_list_params) {
  const { offset = 0, limit = 20, ...rest } = params;
  return client.post({
    url: `${course_item}/get_list`,
    form: {
      ...params,
      offset: 0,
      limit: 9999,
      is_back: 'Y'
    }
  });
}

export async function add_v2(params: course_itemTypes.add_v2_params) {
  return client.post({
    url: `${course_item}/add_v2`,
    form: {
      ...params
    }
  });
}

export async function delete_item(params: course_itemTypes.delete_item_params) {
  return client.post({
    url: `${course_item}/delete`,
    form: {
      ...params
    }
  });
}

export async function get_course_item_publish(
  params: course_itemTypes.get_course_item_publish_params
) {
  return client.post({
    url: `${course_item}/get_course_item_publish`,
    form: {
      ...params
    }
  });
}

export async function update_course_item_publish(
  params: course_itemTypes.update_course_item_publish_params
) {
  return client.post({
    url: `${course_item}/update_course_item_publish`,
    form: {
      ...params
    }
  });
}

export async function update_course_item_download(
  params: course_itemTypes.update_course_item_download_params
) {
  return client.post({
    url: `${course_item}/update_course_item_download`,
    form: {
      ...params
    }
  });
}
